<template>
  <div class="carousel-item-container" @mousemove='handleMouseEvent' @mouseleave="handleOut" ref="container">
    <ImageLoader ref="img" :style="imagePos" :src="this.carousel.bigImg" :placeholder="this.carousel.midImg"
      @load="handleLoad">
    </ImageLoader>
    <div class="title" ref="titleContainer">{{ this.carousel.title }}</div>
    <div class="description" ref="descriptionContainer">{{ this.carousel.description }}</div>
  </div>
</template>

<script>
import ImageLoader from '../../components/ImageLoader';
export default {
  props: ['carousel'],
  components: {
    ImageLoader
  },
  data() {
    return {
      titleWidth: 0,
      descriptionWidth: 0,
      mouseCurrentX: 0, //鼠标当前离视口距离
      mouseCurrentY: 0,
      screenX: 0,  //父组件离视口距离
      screenY: 0,
      mouseInX: 0, //鼠标在组件里面的坐标
      mouseInY: 0,
      containerWidth: 0,//外部容器自身宽度
      containerHeight: 0,//外部容器自身高度
      extraX: 0, //图片相对父元素多余宽度
      extraY: 0,//图片相对父元素多余高度
      left: 0, //x轴偏移量
      top: 0, //y轴偏移量
    }
  },
  mounted() {
    this.titleWidth = this.$refs.titleContainer.clientWidth
    this.descriptionWidth = this.$refs.descriptionContainer.clientWidth;
    this.screenX = this.$refs.container.clientWidth;
    this.screenY = this.$refs.container.clientHeight;
    this.containerWidth = this.$refs.container.clientWidth;
    this.containerHeight = this.$refs.container.clientHeight;
    this.extraX = this.$refs.img.$el.clientWidth - this.containerWidth
    this.extraY = this.$refs.img.$el.clientHeight - this.containerHeight
    this.top = this.extraY / 2;
    this.left = this.extraX / 2;
    window.addEventListener('resize', this.handleResizeFunc)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResizeFunc)
  },
  computed: {

    center() {
      return {
        x: this.containerWidth / 2,
        y: this.containerHeight / 2
      }
    },
    imagePos() {
      return {
        transform: `translate(-${this.left}px,-${this.top}px)`
      }
    },
  },
  methods: {
    handleLoad() {
      this.getTitle(), this.getDesc()
    },
    getTitle() {
      this.$refs.titleContainer.style.opacity = 1;
      this.$refs.titleContainer.style.width = 0 + 'px';
      this.$refs.titleContainer.clientHeight;
      this.$refs.titleContainer.style.transition = '3s';
      this.$refs.titleContainer.style.width = this.titleWidth + 'px'
    },
    getDesc() {
      this.$refs.descriptionContainer.style.opacity = 1;
      this.$refs.descriptionContainer.style.width = 0 + 'px';
      this.$refs.descriptionContainer.clientHeight;
      this.$refs.descriptionContainer.style.transition = '3s 1s';
      this.$refs.descriptionContainer.style.width = this.descriptionWidth + 'px'
    },
    handleMouseEvent(e) {
      this.screenX = this.$refs.container.getBoundingClientRect().left;
      this.screenY = this.$refs.container.getBoundingClientRect().top;
      this.mouseCurrentX = e.clientX;
      this.mouseCurrentY = e.clientY;
      this.mouseInX = this.mouseCurrentX - this.screenX;
      this.mouseInY = this.mouseCurrentY - this.screenY;
      this.left = this.extraX * this.mouseInX / this.containerWidth;
      this.top = this.extraY * this.mouseInY / this.containerHeight;
    },
    handleResizeFunc() {
      if (!this.$refs.container.getBoundingClientRect()) {
        return
      }
      this.screenX = this.$refs.container.getBoundingClientRect().left;
      this.screenY = this.$refs.container.getBoundingClientRect().top;
    },
    handleOut() {
      this.top = this.extraY / 2;
      this.left = this.extraX / 2;
    },

  }
}
</script>

<style scoped lang="less">
.carousel-item-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: #333;
  color: #fff;
  transition: 2s;
  overflow: hidden;

  .image-loader-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 110%;
    height: 110%;
    transition: .3s;
  }
}


.title {
  position: absolute;
  top: 50%;
  transform: translateY(-25px);
  left: 30px;
  font-size: 26px;
  letter-spacing: 5px;
  transition: 2s;
}

.description {
  position: absolute;
  top: 50%;
  transform: translateY(25px);
  left: 30px;
  letter-spacing: 2px;
  color: #999
}

//文字描边 右 左
.title,
.description {
  opacity: 0;
  overflow: hidden;
  white-space: nowrap;
  text-shadow: 1px 0 0 rgba(0, 0, 0, 0.5), -1px 0 0 rgba(0, 0, 0, 0.5), 0 1px 0 rgba(0, 0, 0, 0.5), 0 -1px 0 rgba(0, 0, 0, 0.5)
}
</style>